import AddButton from "components/ui/Button/AddButton/AddButton";
import { Link } from "react-router-dom";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    BRANCH_CREATE_PERMISSION,
    DEPENDENCY_READ_PERMISSION,
} from "components/dashboard/TrainSAM/Dependency/permissions";

const DowntimeBranch = ({
    downtimeCapsule,
    downtimeBranch,
    addDownTimeBranch,
}) => {
    const { classCapsuleEntryId, capsuleId } = downtimeCapsule;
    return (
        <div
            className='d-flex justify-content-between align-items-center'
            style={{ minHeight: "55px" }}>
            {downtimeBranch ? (
                <ComponentAccessControl baseResources={DEPENDENCY_READ_PERMISSION}>
                    <Link
                        to={{
                            pathname: `/t-sam/downtime-collection/${capsuleId}/view/${classCapsuleEntryId}`,
                            state: { downtimeCapsule },
                        }}>
                        <div className='text-primary fw-medium'>
                            View downtime branches
                        </div>
                    </Link>
                </ComponentAccessControl>
            ) : (
                <>
                    <span className='no-space me-2'>
                        No downtime branches added
                    </span>
                    <ComponentAccessControl baseResources={BRANCH_CREATE_PERMISSION}>
                        <AddButton
                            btnText={"Add downtime Branch"}
                            otherClassName='justify-content-end me-2'
                            onClick={addDownTimeBranch}
                        />
                    </ComponentAccessControl>
                </>
            )}
        </div>
    );
};

export default DowntimeBranch;
